import moment from "moment"
import { GalleryList } from './gallery'
import { addDaysToDate } from './time'

class OverviewSalesList extends GalleryList {

    getEntityKey() {
        return 'photographer/overview_sales/totals'
    }
}

export const overviewSalesList = new OverviewSalesList('overview_sales_default')

class OverviewSalesMonth1List extends OverviewSalesList {
    getEntityKey() {
        return 'photographer/overview_sales/totals_month1'
    }
    getBaseUrl() {
        return 'photographer/overview_sales/totals/'
    }
}

class OverviewSalesMonth2List extends OverviewSalesList {
    getEntityKey() {
        return 'photographer/overview_sales/totals_month2'
    }
    getBaseUrl() {
        return 'photographer/overview_sales/totals/'
    }
}

export const overviewSalesMonth1List = new OverviewSalesMonth1List('overview_sales_month1')
export const overviewSalesMonth2List = new OverviewSalesMonth2List('overview_sales_month2')

class OverviewSalesPhotosSoldList extends GalleryList {

  getEntityKey() {
    return 'photographer/overview_sales/photos_sold'
  }

  getData({ created_at_date_from, created_at_date_to }) {
    return this.saveNewObject({
      created_at_date_from: created_at_date_from,
      created_at_date_to: created_at_date_to,
    })
  }
}

export const overviewSalesPhotosSoldList = new OverviewSalesPhotosSoldList('overview_sales_photos_sold_default')

export const fetchPreviousMonths = (setPreviousMonthsFetched, previousMonthsFetched) => {
  return (dispatch, getState) => {
    if (previousMonthsFetched) {
      return
    }
    setPreviousMonthsFetched(true)
    const today = moment()
    ;[1, 2].forEach((monthsAgo) => {
      const list = monthsAgo === 1 ? overviewSalesMonth1List : overviewSalesMonth2List
      const start = today.clone().subtract(monthsAgo, "months").startOf("month").format("YYYY-MM-DD")
      const end = today.clone().subtract(monthsAgo, "months").endOf("month").format("YYYY-MM-DD")
      dispatch(list.updateListFilter({
        created_at_date_from: start,
        created_at_date_to: addDaysToDate(end)
      }))
      dispatch(list.fetchListIfNeeded())
    })
  }
}
